function parseFacetsFromUrl() {
  const hash = typeof window !== 'undefined' ? window.location?.hash : useRoute()?.hash;

  if (!hash) {
    return {};
  }
  const cleanedHash = hash.replace(/^#/, ''); // Remove leading #
  if (!cleanedHash.includes('/')) return {};
  return {
    facets: cleanedHash,
  };
}

export default parseFacetsFromUrl;
